import { OPTIONS } from '../model/demoLead';
import ChoiceGroup from './ChoiceGroup';

/** Step 2: dimensione, tipologie, copertura e tracking. */
export default function FleetStep({ lead, errors, onChoose }) {
  const group = (name) => ({
    id: `demo-${name}`,
    options: OPTIONS[name],
    selected: lead[name],
    error: errors[name],
    onChoose: (value) => onChoose(name, value),
  });

  return (
    <>
      <ChoiceGroup {...group('fleetSize')} label="Quanti mezzi gestite oggi?" hint="1 scelta" />
      <ChoiceGroup
        {...group('vehicleTypes')}
        label="Che tipo di flotta avete?"
        hint="Selezione multipla"
      />
      <ChoiceGroup {...group('coverage')} label="Copertura geografica" hint="Area operativa" />
      <ChoiceGroup
        {...group('trackingState')}
        label="Stato del tracking / telematica"
        hint="Situazione attuale"
      />
    </>
  );
}
